'use strict';

const { h, render } = require('phy');
const HBWBookingLink = require('../components/hbw_booking_link');

module.exports = function renderCheckScheduleButton(buyButtonForm) {
  const container = document.getElementById('hbw-pre-purchase-container');
  if (!container) {
    return null;
  }
  const { touchRequest } = window.payload;
  const { multiOption, is3PIPDeal, hbwPrePurchaseData } = buyButtonForm;
  return render(
    h(HBWBookingLink, {
      hbwPrePurchaseData,
      touchRequest,
      multiOption,
      is3PIPDeal,
    }),
    container
  );
};
